import { DoorOpen } from 'lucide-react';

/** Rooms (#54) get their own icon: channels are # / lock, DMs are avatars. */
export function RoomIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return <DoorOpen className={className} aria-hidden data-testid="room-icon" />;
}
